import { createReducer, on } from '@ngrx/store';
import {StateStatus} from "../../../shared/models/state-status.models";
import {ReportSettingTemplate} from "../../models/report.model";
import {
  addReportSettingTemplate,
  addReportSettingTemplateSuccess,
  loadReportSettingTemplates,
  loadReportSettingTemplatesFailure,
  loadReportSettingTemplatesSuccess,
  modifyReportSettingTemplate,
  modifyReportSettingTemplateFailure,
  modifyReportSettingTemplateSuccess,
  removeReportSettingTemplate,
  removeReportSettingTemplateFailure,
  removeReportSettingTemplateSuccess
} from "./report-template-setting.action";
import {removeReport, removeReportFailure, removeReportSuccess} from "../report/report.action";

export interface ReportSettingTemplateState {
  reportSettingTemplates: ReportSettingTemplate[];
  addedReportSettingTemplate: ReportSettingTemplate | null;
  error: string | null;
  status: StateStatus;
}

export const initialState: ReportSettingTemplateState = {
  reportSettingTemplates: [] as ReportSettingTemplate[],
  addedReportSettingTemplate: null,
  error: null,
  status: 'pending' as StateStatus,
};

export const reportTemplateSettingReducer = createReducer(
  initialState,
  on(loadReportSettingTemplates, (state) => ({ ...state, status: 'loading' as StateStatus })),
  on(loadReportSettingTemplatesSuccess, (state, { reportSettingTemplates }) => ({
    ...state,
    reportSettingTemplates: reportSettingTemplates,
    error: null,
    status: 'loadSuccess' as StateStatus,
  })),
  on(loadReportSettingTemplatesFailure, (state, { error }) => ({
    ...state,
    error: error,
    status: 'error' as StateStatus,
  })),
  on(addReportSettingTemplate, (state, { reportSettingTemplate }) => ({
    ...state,
    status: 'loading' as StateStatus,
  })),
  on(addReportSettingTemplateSuccess, (state, { reportSettingTemplate }) => ({
    ...state,
    addedReportSettingTemplate: reportSettingTemplate,
    reportSettingTemplates: [
      ...state.reportSettingTemplates,
      reportSettingTemplate
    ],
    status: 'loadSuccess' as StateStatus,
  })),

  on(removeReportSettingTemplate, (state, { reportSettingTemplateId }) => ({
    ...state,
    status: 'removing' as StateStatus,
    reportSettingTemplates: state.reportSettingTemplates.filter(reportSettingTemplate => reportSettingTemplateId !== reportSettingTemplate.id)
  })),
  on(removeReportSettingTemplateSuccess, (state) => ({
    ...state,
    status: 'removeSuccess' as StateStatus,
  })),
  on(removeReportSettingTemplateFailure, (state, { error }) => ({
    ...state,
    error: error,
    status: 'removeError' as StateStatus,
  })),
  on(modifyReportSettingTemplate, (state) => ({
    ...state,
    status: 'modifying' as StateStatus,
  })),
  on(modifyReportSettingTemplateSuccess, (state, { reportSettingTemplate}) => ({
    ...state,
    status: 'modifySuccess' as StateStatus,
    reportSettingTemplates: state.reportSettingTemplates.map(template => {
      return template.id === reportSettingTemplate.id ? reportSettingTemplate : template;
    }),
  })),
  on(modifyReportSettingTemplateFailure, (state, { error }) => ({
    ...state,
    error: error,
    status: 'modifyError' as StateStatus,
  })),

);
